import { render, staticRenderFns } from "./admin-syslog.vue?vue&type=template&id=965c48b8&"
import script from "./admin-syslog.vue?vue&type=script&lang=js&"
export * from "./admin-syslog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports